// Libs
import React from 'react';

// Components
import App from 'COMPONENTS/App';

import { Provider } from 'react-redux';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';

// Utils
import './style.css';
import { store } from './store';
import { defaultTheme } from 'UTILS/theme';

const SelfTest = ({ theme: customTheme = {}, ...otherProps }) => {
  const theme = { ...defaultTheme, ...customTheme };
  return (
    <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider theme={createMuiTheme(theme)}>
          <App {...otherProps} />
        </ThemeProvider>
      </Provider>
    </React.StrictMode>
  );
};

export default SelfTest;
